document.addEventListener('DOMContentLoaded', function() {
   const header = document.querySelector('.site-top');
   const mobileToggle = document.getElementById('panel-left-toggle');
   const headerHeight = header.offsetHeight;
   let lastScroll = 0;
   let ticking = false;

   // Add padding to body dynamically
   function updateBodyPadding(shouldHavePadding) {
      if (shouldHavePadding) {
         document.body.style.paddingTop = headerHeight + 'px';
      } else {
         document.body.style.paddingTop = '0px';
      }
   }

   // Update sticky state for both header and mobile toggle
   function updateStickyState(isSticky) {
      if (isSticky) {
         header.classList.add('is-sticky');
         mobileToggle.classList.add('is-sticky');
         updateBodyPadding(true);
      } else {
         header.classList.remove('is-sticky');
         mobileToggle.classList.remove('is-sticky');
         updateBodyPadding(false);
      }
   }

   function handleScroll() {
      const currentScroll = window.pageYOffset;

      // Add sticky class and padding when scrolling down past header height
      if (currentScroll > headerHeight) {
         if (!header.classList.contains('is-sticky')) {
            updateStickyState(true);
         }
      } else {
         // Remove sticky class and padding when at top
         updateStickyState(false);
      }

      lastScroll = currentScroll;
      ticking = false;
   }

   // Throttle scroll events for better performance
   window.addEventListener('scroll', function() {
      if (!ticking) {
         window.requestAnimationFrame(function() {
            handleScroll();
         });
         ticking = true;
      }
   });

   // Initial check in case page loads scrolled down
   handleScroll();
});